"use client";

import { useEffect, useRef } from "react";

/**
 * Renders CMS HTML and re-executes inline <script> tags after mount.
 * React does not run scripts injected via dangerouslySetInnerHTML.
 */
export function NewsArticleBody({
  html,
  className,
}: {
  html: string;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;

    const scripts = Array.from(root.querySelectorAll("script"));
    for (const old of scripts) {
      const next = document.createElement("script");
      for (const { name, value } of Array.from(old.attributes)) {
        next.setAttribute(name, value);
      }
      next.textContent = old.textContent;
      old.replaceWith(next);
    }
  }, [html]);

  return (
    <div
      ref={ref}
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
